/**
 * Resolve a URL that, when navigated to, will land a Hub user inside the
 * Document360 knowledge base — signed in (when possible) and on the page
 * identified by `to`. Falls back to the public Sign in URL whenever the
 * direct exchange isn't available (no access token, network error, server
 * error). The Sign in URL handles error UI and post-login routing, so the
 * fallback degrades gracefully without losing the deep-link target.
 *
 * Doesn't navigate itself — return the URL so callers can choose
 * `window.location.href`, `window.open`, etc.
 */
export const resolveDocument360DeepLinkUrl = async (
  to: string,
  accessToken: string | null | undefined
): Promise<string> => {
  const fallbackUrl = `/auth/document360?redirectPath=${encodeURIComponent(to)}`;

  if (!accessToken) return fallbackUrl;

  try {
    const response = await fetch("/api/document360/generate-code", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ redirectPath: to }),
    });
    const data = (await response.json().catch(() => null)) as { callbackUrl?: string } | null;
    if (response.ok && data?.callbackUrl) return data.callbackUrl;
  } catch (e) {
    console.error("Document360 deep-link exchange failed:", e);
  }

  return fallbackUrl;
};
